import { type EMRKindID, type EMRTypeID } from './_EMR.ts'

// Marker EMR kinds recorded in the patient's Drive folder when they accept each
// document at the onboarding payment step. The accepted document version is
// appended to the kind at record time, e.g.
//   `2026-08-05T12:00:00Z imago.legal.terms-of-use-accepted:2026-08-05`
// so both the acceptance timestamp (the EMR timestamp) and the document version
// are preserved on the user's record.
export const TermsOfUseAccepted_ID = 'imago.legal.terms-of-use-accepted' as EMRTypeID & EMRKindID
export const PrivacyPolicyAccepted_ID = 'imago.legal.privacy-policy-accepted' as EMRTypeID & EMRKindID
export const WithdrawalWaiverAccepted_ID = 'imago.legal.withdrawal-waiver-accepted' as EMRTypeID & EMRKindID

// Each version is the DOCUMENT's own "Last revised" / effective date — not the
// date the user accepts (that is captured separately by the marker's timestamp).
// Bump a version only when that document's text actually changes.
// Terms of Use & Privacy Policy show "Last revised 31.05.2026" at www.imago.tg.
export const TERMS_OF_USE_VERSION = '2026-05-31'
export const PRIVACY_POLICY_VERSION = '2026-05-31'
// The withdrawal clause is our own text (in Pay.tsx); bump when that wording changes.
export const WITHDRAWAL_WAIVER_VERSION = '2026-08-06'

// The versions the user is accepting when they pay. Sent with the buy intent and
// recorded server-side; the checkboxes in the UI gate whether the user may pay.
export interface OnboardingConsentAcceptance {
	termsOfUseVersion: string
	privacyPolicyVersion: string
	withdrawalWaiverVersion: string
}

export const CURRENT_ONBOARDING_CONSENT: OnboardingConsentAcceptance = {
	termsOfUseVersion: TERMS_OF_USE_VERSION,
	privacyPolicyVersion: PRIVACY_POLICY_VERSION,
	withdrawalWaiverVersion: WITHDRAWAL_WAIVER_VERSION,
}
